// Orchard: query rewriter — wraps device model phrases + storage in quotes
// for exact-match Shopify search. Ported from Dawn's processSearchTerms.

const DEVICE_PATTERNS = [
  /\b(iphone\s+(?:se|pro|max|plus|xs|\d+[a-z]*))\b/gi,
  /\b(pixel\s+[0-9]+[a-z]*)\b/gi,
  /\b(galaxy\s+s[0-9]+\+?)\b/gi,
  /\b(ipad\s+(?:pro|air|mini)?\s*[0-9]*)\b/gi,
];

const CAPACITY_PATTERN = /\b\d+\s*[gm]b\b/gi;

/** @param {string} raw */
function rewriteTerms(raw) {
  if (!raw) return raw;
  if (raw.includes('"')) return raw;
  if (CAPACITY_PATTERN.test(raw)) return raw;

  let out = raw;
  for (const pattern of DEVICE_PATTERNS) {
    out = out.replace(pattern, '"$1"');
  }
  return out;
}

/** @param {SubmitEvent} event */
function onSubmit(event) {
  const form = /** @type {HTMLFormElement} */ (event.currentTarget);
  const input = /** @type {HTMLInputElement | null} */ (form.querySelector('input[type="search"][name="q"]'));
  if (!input) return;
  const rewritten = rewriteTerms(input.value);
  if (rewritten !== input.value) input.value = rewritten;
}

function init() {
  const forms = document.querySelectorAll('form[role="search"][action$="/search"]');
  forms.forEach((el) => {
    const form = /** @type {HTMLFormElement} */ (el);
    if (form.dataset.orchardSearchBound) return;
    form.dataset.orchardSearchBound = '1';
    form.addEventListener('submit', onSubmit);
  });
}

if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', init);
} else {
  init();
}
